import React, { useEffect } from "react";
import Navbar from "./navbar";
import Footer from "./footer";
import AOS from "aos";
import "aos/dist/aos.css"; // Import AOS styles
import Skip1 from "../assets/skip1.jpg";


function AboutUs() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true }); // Initialize AOS animations
  }, []);

  return (
    <div className="text-gray-800  font-poppins min-h-screen">
      {/* Navbar */}
      <Navbar />

      {/* Hero Section */}
      <div className="relative py-20  mt-14 px-6 text-center">
        <h1
          className="text-5xl md:text-6xl font-extrabold text-black"
          data-aos="fade-down"
        >
          About Us
        </h1>
        <p
          className="mt-6 text-lg md:text-xl text-black/90 max-w-3xl mx-auto leading-relaxed"
          data-aos="fade-up"
        >
          Empowering businesses with simple and reliable solutions for
          compliance, licensing, and growth. Your success is our passion.
        </p>
      </div>

      {/* Our Mission Section */}
      <div className="py-16 px-6 md:px-20 " data-aos="fade-up">
        <h2 className="text-4xl font-bold text-center mb-8">
          Our Mission & Vision
        </h2>
        <p className="text-lg text-gray-700 max-w-4xl mx-auto leading-relaxed text-center">
          Our mission is to simplify business processes, ensuring you can focus
          on growth while we handle the complexities. With a vision of a future
          where every business thrives without operational hurdles, we work
          tirelessly to support your journey to success.
        </p>
      </div>

      {/* Meet the Team Section */}
      <div className="py-16 px-6 md:px-20">
        <h2
          className="text-4xl font-bold text-center mb-12"
          data-aos="fade-down"
        >
          Meet Our Team
        </h2>
        <div className=" flex justify-center">
          {[
            {
              name: "T.Rakesh",
              role: "Founder & CEO",
              img: Skip1,
            }
          ].map((teamMember, index) => (
            <div
              key={index}
              className="bg-white  shadow-lg rounded-lg   overflow-hidden transform transition duration-300 hover:scale-105 hover:shadow-2xl  hover:shadow-orange-300 hover:bg-orange-100"
              data-aos="zoom-in"
            >
              <img
                src={teamMember.img}
                alt={teamMember.name}
                className="w-full h-48 object-cover"
              />
              <div className="p-6 text-center">
                <h3 className="text-xl font-bold">{teamMember.name}</h3>
                <p className="mt-2 text-gray-600">{teamMember.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Why Choose Us Section */}
      <div className="py-16 px-6 md:px-20 ">
        <h2
          className="text-4xl font-bold text-center mb-12"
          data-aos="fade-right"
        >
          Why Choose Us?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {[
            {
              title: "Expert Guidance",
              description:
                "Our team of experts ensures a seamless experience from start to finish.",
              icon: "💡",
            },
            {
              title: "Reliable Services",
              description:
                "We provide dependable solutions for licensing, compliance, and registration.",
              icon: "✅",
            },
            {
              title: "Customer Focused",
              description:
                "Your satisfaction is our priority. We’re here to support you at every step.",
              icon: "💼",
            },
          ].map((reason, index) => (
            <div
              key={index}
              className="bg-white shadow-md rounded-lg p-8 text-center"
              data-aos="flip-left"
            >
              <div className="text-5xl mb-4">{reason.icon}</div>
              <h3 className="text-xl font-bold mb-2">{reason.title}</h3>
              <p className="text-gray-600">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Call to Action */}
      <div className="py-16  text-center" data-aos="fade-up">
        <h2 className="text-4xl font-bold text-black">
          Ready to Start Your Journey?
        </h2>
        <p className="mt-4 text-lg text-orange max-w-3xl mx-auto">
          Partner with us and take the first step toward simplifying your
          business processes. Let’s grow together!
        </p>
        <button
  className="mt-6 px-6 py-3 btn-primary inline-block border-2 border-orange-600 rounded-full hover:bg-orange-600 hover:text-white transition"
  onClick={() => window.location.href = "tel:9014526049"}
>
  Contact Us
</button>

      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default AboutUs;
